// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductVariationList__wrapper___lX5v2","items":"ProductVariationList__items___qzJzf","item":"ProductVariationList__item___tqsh3"};